"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20TransferDocumentBuilder = void 0;
var LogRelatedId_1 = require("../common/LogRelatedId");
var Erc20TransferDocumentBuilder = /** @class */ (function () {
    function Erc20TransferDocumentBuilder() {
    }
    Erc20TransferDocumentBuilder.build = function (transfer, block, confirmed, chainId) {
        var chain = Number(chainId);
        var document = {
            id: LogRelatedId_1.LogRelatedId.create(chain, transfer.transactionHash, transfer.logIndex),
            transactionHash: transfer.transactionHash,
            contract: transfer.contract,
            logIndex: transfer.logIndex,
            from: transfer.from,
            to: transfer.to,
            value: transfer.value,
            tokenDecimals: parseInt(transfer.tokenDecimals, 10),
            tokenName: transfer.tokenName,
            tokenSymbol: transfer.tokenSymbol,
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
            chainId: chain,
        };
        return document;
    };
    return Erc20TransferDocumentBuilder;
}());
exports.Erc20TransferDocumentBuilder = Erc20TransferDocumentBuilder;
//# sourceMappingURL=Erc20TransferDocumentBuilder.js.map